var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg331X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "125px",
    viewBox: "0 0 160 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "33@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "motivations/resources",
    transform: "translate(-108.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 33,
    transform: "translate(108.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5285986,21.1367394 C39.2060552,22.0234782 24.3591478,28.3938227 14.3156995,36.2690181 C0.694969216,46.9492057 -7.96370103,73.0925095 10.7919227,94.1627761 C38.2953967,125.06047 134.387788,138.948359 155.634132,106.155795 C175.28035,75.8329384 126.16665,17.8149285 57.5285986,21.1367394 Z",
    id: "Path-55",
    fill: "#F1EEEC",
    transform: "translate(80.000000, 73.000000) scale(-1, 1) translate(-80.000000, -73.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(80.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    points: "0 89 35 89 35 10 0 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    points: "51 78 35 89 35 10 51 -6.32383035e-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 9.57600085 34.7350005 19.5760008 35.2649995 20.4239992 51.2649995 10.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 19.5760008 34.7350005 29.5760008 35.2649995 30.4239992 51.2649995 20.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 29.5760008 34.7350005 39.5760008 35.2649995 40.4239992 51.2649995 30.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 39.5760008 34.7350005 49.5760008 35.2649995 50.4239992 51.2649995 40.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 49.5760008 34.7350005 59.5760008 35.2649995 60.4239992 51.2649995 50.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 59.5760008 34.7350005 69.5760008 35.2649995 70.4239992 51.2649995 60.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "50.7350005 69.5760008 34.7350005 79.5760008 35.2649995 80.4239992 51.2649995 70.4239992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "45.5 3.5 44.5 3.5 44.5 82.3502275 45.5 82.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "42.5 5.5 41.5 5.5 41.5 84.3502275 42.5 84.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "48.5 1.5 47.5 1.5 47.5 80.3502275 48.5 80.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#B5E9F7",
    fillRule: "nonzero",
    points: "39.5 7.5 38.5 7.5 38.5 86.3502275 39.5 86.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "5.5 10.5 4.5 10.5 4.5 89.3502275 5.5 89.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "10.5 10.5 9.5 10.5 9.5 89.3502275 10.5 89.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "15.5 10.5 14.5 10.5 14.5 89.3502275 15.5 89.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "20.5 10.5 19.5 10.5 19.5 89.3502275 20.5 89.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "25.5 10.5 24.5 10.5 24.5 89.3502275 25.5 89.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-21",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "30.5 10.5 29.5 10.5 29.5 89.3502275 30.5 89.3502275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 19.5 0 19.5 0 20.5 35 20.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 29.5 0 29.5 0 30.5 35 30.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 39.5 0 39.5 0 40.5 35 40.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 49.5 0 49.5 0 50.5 35 50.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 59.5 0 59.5 0 60.5 35 60.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 69.5 0 69.5 0 70.5 35 70.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero",
    points: "35 79.5 0 79.5 0 80.5 35 80.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,9.5 C35.2761424,9.5 35.5,9.72385763 35.5,10 L35.5,89 C35.5,89.2761424 35.2761424,89.5 35,89.5 L0,89.5 C-0.276142375,89.5 -0.5,89.2761424 -0.5,89 L-0.5,10 C-0.5,9.72385763 -0.276142375,9.5 0,9.5 L35,9.5 Z M34.5,10.5 L0.5,10.5 L0.5,88.5 L34.5,88.5 L34.5,10.5 Z",
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7350005,-0.423999152 C51.0680245,-0.632139154 51.5,-0.39271777 51.5,0 L51.5,78 C51.5,78.1646483 51.4189416,78.3187429 51.2832644,78.412021 L35.2832644,89.412021 C34.9515136,89.6400996 34.5,89.4025897 34.5,89 L34.5,10 C34.5,9.82760498 34.5888098,9.66737002 34.7350005,9.57600085 L50.7350005,-0.423999152 Z M50.5,0.902123821 L35.5,10.2771238 L35.5,88.0494848 L50.5,77.7369848 L50.5,0.902123821 Z",
    id: "Rectangle",
    fill: "#8ED6EA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 79.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 74.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 69.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 69.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.500000, 80.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.500000, 75.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.500000, 70.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.500000, 65.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.500000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18.5 L31.5,13.4611317 C31.5,9.61660483 24.5604136,6.5 16,6.5 C11.8758281,6.5 8.12785781,7.22337879 5.35084189,8.40302982 C2.36369346,9.67194322 0.5,11.4687922 0.5,13.4611317 L0.5,18.5 L5.44168906,18.5 L31.5,18.5 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.500000) scale(1, -1) translate(-16.000000, -12.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.7672477 C6.94089221,11.6472983 4.9547811,12.4694995 3.54166667,13.2338513 L3.5,17.9332072 C4.83426185,17.1298175 5.83426185,16.6279976 6.5,16.4277475 C7.16573815,16.2274974 8.21387333,16.0451149 9.64440554,15.8806 L9.5,10.7672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 14.350227) scale(1, -1) translate(-6.572203, -14.350227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18.5 L32,13.8810374 C32,9.95941759 24.8113613,7 16,7 C7.18863871,7 0,9.95941759 0,13.8810374 L0,18.5 L1,18.5 L1,13.8810374 C1,10.7543579 7.69053404,8 16,8 C24.309466,8 31,10.7543579 31,13.8810374 L31,18.5 L32,18.5 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.750000) scale(1, -1) translate(-16.000000, -12.750000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 7,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.809925,0 32,3.01519273 32,7 C32,10.9848073 24.809925,14 16,14 C7.19007496,14 0,10.9848073 0,7 C0,3.01519273 7.19007496,0 16,0 Z M16,1 C7.68909779,1 1,3.80510553 1,7 C1,10.1948945 7.68909779,13 16,13 C24.3109022,13 31,10.1948945 31,7 C31,3.80510553 24.3109022,1 16,1 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 79.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 74.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 69.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 69.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.500000, 80.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.500000, 75.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.500000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18.5 L31.5,13.4611317 C31.5,9.61660483 24.5604136,6.5 16,6.5 C11.8758281,6.5 8.12785781,7.22337879 5.35084189,8.40302982 C2.36369346,9.67194322 0.5,11.4687922 0.5,13.4611317 L0.5,18.5 L5.44168906,18.5 L31.5,18.5 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.500000) scale(1, -1) translate(-16.000000, -12.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.7672477 C6.94089221,11.6472983 4.9547811,12.4694995 3.54166667,13.2338513 L3.5,17.9332072 C4.83426185,17.1298175 5.83426185,16.6279976 6.5,16.4277475 C7.16573815,16.2274974 8.21387333,16.0451149 9.64440554,15.8806 L9.5,10.7672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 14.350227) scale(1, -1) translate(-6.572203, -14.350227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18.5 L32,13.8810374 C32,9.95941759 24.8113613,7 16,7 C7.18863871,7 0,9.95941759 0,13.8810374 L0,18.5 L1,18.5 L1,13.8810374 C1,10.7543579 7.69053404,8 16,8 C24.309466,8 31,10.7543579 31,13.8810374 L31,18.5 L32,18.5 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.750000) scale(1, -1) translate(-16.000000, -12.750000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 7,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.809925,0 32,3.01519273 32,7 C32,10.9848073 24.809925,14 16,14 C7.19007496,14 0,10.9848073 0,7 C0,3.01519273 7.19007496,0 16,0 Z M16,1 C7.68909779,1 1,3.80510553 1,7 C1,10.1948945 7.68909779,13 16,13 C24.3109022,13 31,10.1948945 31,7 C31,3.80510553 24.3109022,1 16,1 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.70982,25.3634967 C110.085278,25.2583684 110.431245,25.6043356 110.326117,25.9797937 L110.326117,25.9797937 L107.851243,34.8186284 C107.776787,35.0845436 107.500861,35.2397517 107.234946,35.1652955 C106.969031,35.0908392 106.813823,34.8149137 106.888279,34.5489985 L106.888279,34.5489985 L108.848,27.548 L87.0431667,49.3535534 C86.8696004,49.5271197 86.600176,49.5464049 86.4053078,49.4114088 L86.33606,49.3535534 L77.1346347,40.1521281 L15.349876,101.936887 C15.1546139,102.132149 14.8380314,102.132149 14.6427692,101.936887 C14.4475071,101.741625 14.4475071,101.425042 14.6427692,101.22978 L14.6427692,101.22978 L76.7810813,39.0914679 C76.9763434,38.8962058 77.2929259,38.8962058 77.488188,39.0914679 L77.488188,39.0914679 L86.6896133,48.2928932 L108.14,26.841 L101.140615,28.8013345 C100.904246,28.8675178 100.659967,28.7522379 100.556308,28.5390424 L100.524318,28.4546674 C100.449862,28.1887522 100.60507,27.9128267 100.870985,27.8383704 L100.870985,27.8383704 L109.70982,25.3634967 Z",
    id: "Path-85",
    fill: "#302745",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 88.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 83.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 78.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 78.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 73.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 68.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 89.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 84.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 79.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 74.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 69.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 63.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 58.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 53.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 53.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 48.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(41.000000, 43.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.583333, 0.583333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4166667,18.4166667 L31.4166667,13.3777984 C31.4166667,9.5332715 24.4770803,6.41666667 15.9166667,6.41666667 C11.7924947,6.41666667 8.04452448,7.14004545 5.26750856,8.31969649 C2.28036013,9.58860989 0.416666667,11.3854589 0.416666667,13.3777984 L0.416666667,18.4166667 L5.35835572,18.4166667 L31.4166667,18.4166667 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(15.916667, 12.416667) scale(1, -1) translate(-15.916667, -12.416667) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41666667,10.6839144 C6.85755887,11.563965 4.87144776,12.3861662 3.45833333,13.150518 L3.41666667,17.8498739 C4.75092851,17.0464842 5.75092851,16.5446643 6.41666667,16.3444142 C7.08240482,16.1441641 8.13054,15.9617816 9.5610722,15.7972666 L9.41666667,10.6839144 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.488869, 14.266894) scale(1, -1) translate(-6.488869, -14.266894) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9166667,18.4166667 L31.9166667,13.7977041 C31.9166667,9.87608425 24.728028,6.91666667 15.9166667,6.91666667 C7.10530538,6.91666667 -0.0833333333,9.87608425 -0.0833333333,13.7977041 L-0.0833333333,18.4166667 L0.916666667,18.4166667 L0.916666667,13.7977041 C0.916666667,10.6710246 7.60720071,7.91666667 15.9166667,7.91666667 C24.2261326,7.91666667 30.9166667,10.6710246 30.9166667,13.7977041 L30.9166667,18.4166667 L31.9166667,18.4166667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero",
    transform: "translate(15.916667, 12.666667) scale(1, -1) translate(-15.916667, -12.666667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 15.9166667,
    cy: 6.91666667,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9166667,-0.0833333333 C24.7265917,-0.0833333333 31.9166667,2.93185939 31.9166667,6.91666667 C31.9166667,10.9014739 24.7265917,13.9166667 15.9166667,13.9166667 C7.10674163,13.9166667 -0.0833333333,10.9014739 -0.0833333333,6.91666667 C-0.0833333333,2.93185939 7.10674163,-0.0833333333 15.9166667,-0.0833333333 Z M15.9166667,0.916666667 C7.60576446,0.916666667 0.916666667,3.72177219 0.916666667,6.91666667 C0.916666667,10.1115611 7.60576446,12.9166667 15.9166667,12.9166667 C24.2275689,12.9166667 30.9166667,10.1115611 30.9166667,6.91666667 C30.9166667,3.72177219 24.2275689,0.916666667 15.9166667,0.916666667 Z",
    id: "Oval",
    fill: "#302745",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 64.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 59.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 54.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 49.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18 L31.5,12.9611317 C31.5,9.11660483 24.5604136,6 16,6 C11.8758281,6 8.12785781,6.72337879 5.35084189,7.90302982 C2.36369346,9.17194322 0.5,10.9687922 0.5,12.9611317 L0.5,18 L5.44168906,18 L31.5,18 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.000000) scale(1, -1) translate(-16.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.2672477 C6.94089221,11.1472983 4.9547811,11.9694995 3.54166667,12.7338513 L3.5,17.4332072 C4.83426185,16.6298175 5.83426185,16.1279976 6.5,15.9277475 C7.16573815,15.7274974 8.21387333,15.5451149 9.64440554,15.3806 L9.5,10.2672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 13.850227) scale(1, -1) translate(-6.572203, -13.850227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18 L32,13.3810374 C32,9.45941759 24.8113613,6.5 16,6.5 C7.18863871,6.5 0,9.45941759 0,13.3810374 L0,18 L1,18 L1,13.3810374 C1,10.2543579 7.69053404,7.5 16,7.5 C24.309466,7.5 31,10.2543579 31,13.3810374 L31,18 L32,18 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.250000) scale(1, -1) translate(-16.000000, -12.250000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 6.5,
    rx: 15.5,
    ry: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.500000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18.5 L31.5,13.4611317 C31.5,9.61660483 24.5604136,6.5 16,6.5 C11.8758281,6.5 8.12785781,7.22337879 5.35084189,8.40302982 C2.36369346,9.67194322 0.5,11.4687922 0.5,13.4611317 L0.5,18.5 L5.44168906,18.5 L31.5,18.5 Z",
    id: "Oval",
    fill: "#FFBF5C",
    transform: "translate(16.000000, 12.500000) scale(1, -1) translate(-16.000000, -12.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10.7672477 C6.94089221,11.6472983 4.9547811,12.4694995 3.54166667,13.2338513 L3.5,17.9332072 C4.83426185,17.1298175 5.83426185,16.6279976 6.5,16.4277475 C7.16573815,16.2274974 8.21387333,16.0451149 9.64440554,15.8806 L9.5,10.7672477 Z",
    id: "Oval",
    fill: "#FFDF97",
    transform: "translate(6.572203, 14.350227) scale(1, -1) translate(-6.572203, -14.350227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,18.5 L32,13.8810374 C32,9.95941759 24.8113613,7 16,7 C7.18863871,7 0,9.95941759 0,13.8810374 L0,18.5 L1,18.5 L1,13.8810374 C1,10.7543579 7.69053404,8 16,8 C24.309466,8 31,10.7543579 31,13.8810374 L31,18.5 L32,18.5 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero",
    transform: "translate(16.000000, 12.750000) scale(1, -1) translate(-16.000000, -12.750000) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFDF97",
    cx: 16,
    cy: 7,
    rx: 15.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.809925,0 32,3.01519273 32,7 C32,10.9848073 24.809925,14 16,14 C7.19007496,14 0,10.9848073 0,7 C0,3.01519273 7.19007496,0 16,0 Z M16,1 C7.68909779,1 1,3.80510553 1,7 C1,10.1948945 7.68909779,13 16,13 C24.3109022,13 31,10.1948945 31,7 C31,3.80510553 24.3109022,1 16,1 Z",
    id: "Oval",
    fill: "#9A6D46",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131,0 C131.502345,0 131.690987,0.657756932 131.264999,0.923999152 L115.264999,10.9239992 C115.185534,10.9736653 115.09371,11 115,11 L80,11 C79.4976552,11 79.309013,10.3422431 79.7350005,10.0760008 L95.7350005,0.076000848 C95.8144663,0.0263347224 95.9062901,0 96,0 L131,0 Z",
    id: "Rectangle",
    fill: "#B5E9F7",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg331X);
export default __webpack_public_path__ + "static/media/33@1x.53851354.svg";
export { ForwardRef as ReactComponent };